import classNames from "classnames";
import React, { ReactNode } from "react";

import { useInAppDarkMode } from "@/hooks/useInAppDarkMode";

import styles from "./in-app-notification-shell.module.scss";

type Props = {
    children: ReactNode;
};

/*
 * Wrapper for the in-app (webview) legacy confirmation and error notifications.
 * Applies the global "arcade" class so the notification's :global(.arcade) styles
 * match in every locale (the class otherwise only exists on en-US), and the global
 * "dark" class + a black full-screen backdrop when the app renders dark.
 */
export const InAppNotificationShell: React.FC<Props> = ({ children }) => {
    const isDark = useInAppDarkMode();

    return (
        <div className={classNames("arcade", { dark: isDark, [styles.dark]: isDark })}>
            {children}
        </div>
    );
};
